import React, { Component } from 'react';
import { Nav } from './nav';
import { Item } from './item';

import './styles/styleguide.scss';

export default class Styleguide extends Component {
  constructor() {
    super();
    this.state = {
      activeCategory: 'elements',
      activeItem: 'buttons',
    };
    this.updateMainState = this.updateMainState.bind(this);
  }

  componentDidMount() {
    $('.menu-item').on('click', (e) => this.handleScroll(e));
  }

  handleScroll(e) {
    const el = e.currentTarget.id.replace('-', '');
    const scrollAmount = $(`#${el}-container`).offset().top + $('#styleguide-page').scrollTop();

    window.scrollTo(0, scrollAmount);
  }

  updateMainState(obj) {
    Object.keys(obj).forEach((key) => this.setState({ [key]: obj[key] }));
  }

  handleMenuClick(item) {
    this.setState({ activeCategory: item });
  }

  Intro() {
    return (
      <section className="introduction">
        <h1 className="category-title">Brandfolder's Styleguide</h1>
        <p className="item-desc">To apply the styling found below, add specified classes to the elements and import the relevant SCSS file. The SCSS files are found in the directory <i>library_master</i> with a file structure that mirrors the styleguide menu.</p>
        <p className="item-desc">Utility styling such as <i>flexbox mixins</i>, <i>transitions</i>, <i>border radius</i> etc. should also be pulled in from <i>library_master</i>.</p>
      </section>
    );
  }

  render() {
    return (
      <div className="styleguide-component">
        <div id="styleguide-page">
          <Nav
            activeCategory={this.state.activeCategory}
            activeItem={this.state.activeItem}
            updateMainState={this.updateMainState}
          />
          <div className="category-container">
            { this.Intro() }
            <section className="elements">
              <h2 className="category-title">Elements</h2>
              <Item itemType="Buttons" />
              <Item itemType="Checkboxes" />
              <Item itemType="Inputs" />
              <Item itemType="Labels" />
              <Item itemType="RadioButtons" />
            </section>
            <section className="style">
              <h2 className="category-title">Styles</h2>
              <Item itemType="Typography" />
              <Item itemType="Colors" />
              <Item itemType="Icons" />
            </section>
          </div>
        </div>
      </div>
    );
  }
}
